import { render, staticRenderFns } from "./DueLeads.vue?vue&type=template&id=3770dcca&scoped=true&lang=pug"
import script from "./DueLeads.vue?vue&type=script&lang=js"
export * from "./DueLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3770dcca",
  null
  
)

export default component.exports